export default __webpack_public_path__ + "static/media/trunamomy-dentin.2467ad37.svg";